export class ValidationException extends Error {
  constructor(message: string, error) {
    super(message);
    this.name = 'ValidationException';
    this.stack = error
    Object.setPrototypeOf(this, ValidationException.prototype);
  }
}
